export default class Cleaner {
  constructor(inputConfig) {
    const config = { ...inputConfig }
    config.removeLookup = {}
    config.remove.forEach(tagName => (config.removeLookup[tagName] = true))
    config.unwrapLookup = {}
    config.unwrap.forEach(tagName => (config.unwrapLookup[tagName] = true))
    this.config = config
  }

  replaceNode(parent, original, replacement) {
    while (original.hasChildNodes())
      replacement.appendChild(original.firstChild)
    parent.replaceChild(replacement, original)
    return replacement
  }

  unwrapNode(node) {
    var parent = node.parentNode
    while (node.lastChild) parent.insertBefore(node.lastChild, node.nextSibling) // insertAfter
    parent.removeChild(node)
  }

  cleanupNode(node) {
    const config = this.config
    const staticNodeList = Array.from(node.childNodes)
    // first pass, remove nodes
    // We need to do it on a static array as node.childNodes is a living colletion
    staticNodeList.forEach(n => {
      const tagName = n.tagName && n.tagName.toLowerCase()
      if (config.removeLookup[tagName]) node.removeChild(n)
    })
    node.childNodes.forEach(n => {
      const tagName = n.tagName && n.tagName.toLowerCase()

      // unwrap the node and return
      // unwrapping will put children after the unrapped node, so after we move them
      // we will clean them up
      if (config.unwrapLookup[tagName]) return this.unwrapNode(n) // return as

      // if we have replacements
      if (config.replace[tagName]) {
        const replacementName = config.replace[tagName]
        n = this.replaceNode(node, n, document.createElement(replacementName))
      }

      // remove any classes
      if (
        config.removeClasses &&
        n &&
        n.hasAttribute &&
        n.hasAttribute('class')
      ) {
        n.removeAttribute('class')
      }

      // remove any styles
      if (
        config.removeStyles &&
        n &&
        n.hasAttribute &&
        n.hasAttribute('style')
      ) {
        n.removeAttribute('style')
      }
    })
    // recursively clean down
    node.childNodes.forEach(n => this.cleanupNode(n))
    return node
  }

  cleanup(string) {
    console.log(string)
    const div = document.createElement('div')
    div.innerHTML = string
    this.cleanupNode(div)
    return div.innerHTML
  }
}
